import React, { useState } from 'react';
import './Login.css';
import '../Auth/Auth.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import logo from '../../../images/4.png';

export default function Login() {
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [cargando, setCargando] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCargando(true);

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('contrasena', contrasena);

            const response = await fetch(`${baseURL}/login.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                // Recarga para que MainLayout vuelva a consultar userLogued.php
                // con la sesión ya iniciada.
                window.location.reload();
            } else {
                toast.error(data.error || 'No se pudo iniciar sesión.');
                setCargando(false);
            }
        } catch (error) {
            console.error('Error de login:', error);
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
            setCargando(false);
        }
    };

    return (
        <div className='AuthContainer'>
            <ToastContainer />
            <div className='formContain'>
                <img src={logo} alt='Ruta 20 motos' className='logoAtuh' style={{ backgroundColor: '#641613', padding: '10px', borderRadius: '8px' }} />
                <h2>Iniciar sesión</h2>
                <form className='formAuth' onSubmit={handleSubmit}>
                    <div className='inputsAuth'>
                        <label htmlFor='email'>Email</label>
                        <div className='deFlexInputs'>
                            <input
                                type='email'
                                id='email'
                                name='email'
                                placeholder='Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className='inputsAuth'>
                        <label htmlFor='contrasena'>Contraseña</label>
                        <div className='deFlexInputs'>
                            <input
                                type='password'
                                id='contrasena'
                                name='contrasena'
                                placeholder='Contraseña'
                                value={contrasena}
                                onChange={(e) => setContrasena(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <button type='submit' className='btn' disabled={cargando}>
                        {cargando ? 'Ingresando...' : 'Ingresar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
